'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var SdkError = require('../../errors/SdkError.cjs');

class WalletAdapterIdentityDriver {
  constructor(walletAdapter) {
    this.walletAdapter = walletAdapter;
  }
  get publicKey() {
    if (!this.walletAdapter.publicKey) {
      throw new SdkError.UninitializedWalletAdapterError();
    }
    return this.walletAdapter.publicKey;
  }
  async signMessage(message) {
    if (this.walletAdapter.signMessage === undefined) {
      throw new SdkError.OperationNotSupportedByWalletAdapterError('signMessage');
    }
    return this.walletAdapter.signMessage(message);
  }
  async signTransaction(transaction) {
    if (this.walletAdapter.signTransaction === undefined) {
      throw new SdkError.OperationNotSupportedByWalletAdapterError('signTransaction');
    }
    return this.walletAdapter.signTransaction(transaction);
  }
  async signAllTransactions(transactions) {
    if (this.walletAdapter.signAllTransactions === undefined) {
      throw new SdkError.OperationNotSupportedByWalletAdapterError('signAllTransactions');
    }
    return this.walletAdapter.signAllTransactions(transactions);
  }
}

exports.WalletAdapterIdentityDriver = WalletAdapterIdentityDriver;
//# sourceMappingURL=WalletAdapterIdentityDriver.cjs.map
